import { type StoreState } from '../types/StoreState';
import { type ExpressPaymentMethods } from '../types/PaymentMethods';

export const selectHighestSupportedApplePayVersion = (state: StoreState): number =>
  state.appState.highestSupportedApplePayVersion;

export const selectApCanMakePayments = (state: StoreState): boolean => state.appState.applePayCanMakePayments;

export const selectPayPalMethodsEligibility = (state: StoreState) => {
  return state.appState.payPalMethodsEligibility;
};

export const selectWidgetRootWrapperDh = (state: StoreState) => {
  return state.appState.widgetRootWrapperDh;
};

export const selectSessionId = (state: StoreState) => state.appState.sessionId;

export const selectExperiments = (state: StoreState) => state.appState.experiments;

export const selectPaymentMethods = (state: StoreState): ExpressPaymentMethods => state.domain.paymentMethods;
